import gql from 'graphql-tag';

export default gql`
  mutation updateFeedback($input: UpdateFeedbackInput!) {
    updateFeedback(input: $input) {
      success
      userErrors {
        field
        message
      }
    }
  }
`;
